import React from 'react';
import { ShimmerCircularImage, ShimmerTitle } from "react-shimmer-effects";

const ReactionListLoader = () => {
  
  return (
    <>
      {
        Array.from({ length: 8 }).map((_, index) => {
          return (
            <div className={`mx-n-15 pd-x-15 d-flex align-items-center ${index === 0 ? 'pd-b-15' : 'pd-y-15 border-top border-gray-700'}`}>
              <div className="d-flex align-items-center w-100">
                <div className="d-flex align-items-center flex-1">
                  <ShimmerCircularImage size={30} className="mg-b-0" />
                  <div className='w-25'><ShimmerTitle line={1} gap={0} variant="primary" className="mg-l-10 mg-b-0 d-block" /></div>
                </div>
                <ShimmerCircularImage size={20} className="mg-b-0" />
              </div>
            </div>
          )
        })
      }
    </>
  );
};

export default ReactionListLoader;
